module.exports = __webpack_public_path__ + "static/img/sy_t2_2.f5fb18d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/sy_t2_2.png
// module id = 4TYQ
// module chunks = 16